module.exports = __webpack_public_path__ + "static/media/S4N7-1.8963fe12.svg";